import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import CollapsedComment from './CollapsedComment';
import ExpandedComment from './ExpandedComment';

import { Else, If, Then } from 'react-if';

const CommentNodeWidget = ({ commentId, engine, node }) => {
  const { commentsVisible: allVisible, executing } = useSelector(state => state.datascienceState.creatorState.basicState),
        [visible, setVisible] = useState(allVisible),
        setVisiblePassedToCollapsed = useCallback(() => setVisible(true), []),
        setVisiblePassedToExpanded = useCallback(() => setVisible(false), [])

  useEffect(() => {
    setVisible(visible => visible !== allVisible ? allVisible : visible)
    if(executing) {
      setVisible(false)
    }
  }, [allVisible, executing])

  return (
    <div className="data-science__pipeline-creator__comments__comment">
      <If condition={visible}>
        <Then>
          <ExpandedComment
              commentId={commentId}
              engine={engine}
              node={node}
              setVisible={setVisiblePassedToExpanded}
          />
        </Then>
        <Else>
          <CollapsedComment
              commentId={commentId}
              setVisible={setVisiblePassedToCollapsed}
          />
        </Else>
      </If>
    </div>
  )
}

CommentNodeWidget.propTypes = {
  commentId: PropTypes.string.isRequired,
  engine: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
}

export default CommentNodeWidget;